import { faWrench } from '@fortawesome/pro-regular-svg-icons';
import {
    Label as LabelPrimitive,
    Readable,
    Toggle,
    downstream,
    upstream,
} from 'components/filter/filters-next/SharedToggleProps';
import { FilterIcon, LabelFilterComponent, ServerKey } from 'components/filter/types';

export const filterKey: ServerKey = 'potentialIssueAddress';
export const Label: LabelFilterComponent = () => <LabelPrimitive>Potential issue</LabelPrimitive>;
export const Icon: FilterIcon = faWrench;
export { Toggle, Readable, downstream, upstream };
